import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';
import { TokenService } from '../../services';
import { Invoice } from './invoice.model';
import { stringify } from 'querystring';

interface InvoicesResponse {
  data: Invoice[];
}

@Injectable()
export class InvoiceService {
  constructor(
    private token: TokenService,
    private http: HttpClient,
  ) {}

  get(page: number = 1) {
    return this.http
      .get<any>(`${config.apiLocation}/v1/invoices?${stringify({ page })}`)
      .map(res => res);
      // .get<InvoicesResponse>(`${config.apiLocation}/v1/invoices?{stringify({ terms, page })}`)
      // .map(res => res.data);
  }

  getForClient(id: string): Observable<Invoice[]> {
    return this.http
      .get<InvoicesResponse>(`${config.apiLocation}/v1/clients/${id}/invoices`)
      .map(res => res.data);
  }

  update(id: string, body) {
      return this.http
        .patch(`${config.apiLocation}/v1/invoices/${id}`, body);
  }

  /**
   * Get an invoice's download URL.
   *
   * @todo Revisit this authentication method.
   *       A better solution could be to create a post form and inject the token
   *       as a post parameter of `token` instead.
   *
   * @param {Invoice} invoice
   * @return {Observable<string>}
   */
  downloadUrl(invoice: Invoice): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/invoices/${invoice.id}/download?token=${token}`);
  }

  /**
   * Get an invoice in CSV format.
   *
   * @todo Revisit this authentication method.
   *       A better solution could be to create a post form and inject the token
   *       as a post parameter of `token` instead.
   *
   * @param {Invoice} invoice
   * @return {Observable<string>}
   */
  downloadCsv(invoice: Invoice): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/invoices/${invoice.id}/csv?token=${token}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/invoices/invoice.service.ts